var include_campaign_pickup = `
<div class="contents-wrap mt60">
	<a href="https://www.7card.co.jp/lp/plus/nnchp12.html" target="_blank" class="campaign-banner Nanaco_Lead7cardLink CvCpRecommend01 Nanaco_CpRecommend">
		<img src="/material/img/common/bnr/bnr_7cardplus_2003_pc.jpg" width="100%" alt="年会費永年無料 セブンカード・プラス 入会キャンペーン実施中! 最大6,600nanacoポイントプレゼント 2024年8月1日(木)～2024年8月31日(土)" class="pc-only">
		<img src="/material/img/common/bnr/bnr_7cardplus_2003_sp.jpg" alt="年会費永年無料 セブンカード・プラス 入会キャンペーン実施中! 最大6,600nanacoポイントプレゼント 2024年8月1日(木)～2024年8月31日(土)" class="sp-only">
	</a>
	<div class="grid-wrapper mt20 grid-top-margin">
		<div class="grid grid--4 grid--sp-2">
			<div class="grid-item grid-item-mt10-sp">
				<div class="campaign-banner__wrap">
					<a href="https://www.sej.co.jp/cmp/app_nnc2408.html" class="campaign-banner Nanaco_CpRecommend" target="_blank">
						<img src="/material/img/common/bnr/bnr_point_sej_app2408_c.png" alt="アプリに登録したnanacoでお買い物すると カードもモバイルもnanacoポイント5倍 実施期間8/9(金)～8/31(土) 通常、200円(税抜)ごと1ポイント付与に対して、5倍のポイントが付与されます。ボーナスポイントは9/10(火)に付与。">
					</a>
				</div>
			</div>
			<div class="grid-item grid-item-mt10-sp">
				<div class="campaign-banner__wrap">
					<a href="/how-to/group/sej_nanaco.html" class="campaign-banner Nanaco_CpRecommend">
						<img src="/material/img/common/bnr/bnr_sej_app2402_c.png" alt="セブン‐イレブンアプリに登録したnanacoで支払うとダブルでたまってもっとおトク!">
					</a>
				</div>
			</div>
			<div class="grid-item grid-item-mt10-sp">
				<div class="campaign-banner__wrap">
					<a href="/n/b7.html?utm_source=nanaco-net.jp&utm_medium=banner&utm_campaign=nanacoapp2402_nanaco" class="campaign-banner Nanaco_CpRecommend" target="_blank">
						<img src="/material/img/common/bnr/bnr_mobile_app2402_c.png" alt="nanacoモバイル アプリなら楽々確認 詳しくはこちら">
					</a>
				</div>
			</div>
			<div class="grid-item grid-item-mt10-sp">
				<div class="campaign-banner__wrap">
					<a href="https://nanaco.hoken.7-insurance.jp/plan/mitsumori/?utm_source=nanacoHP&utm_medium=referral&utm_campaign=CP+column" class="campaign-banner Nanaco_CpRecommend" target="_blank">
						<img src="/material/img/common/bnr/bnr_nanaco_insurance2407_c.png" alt="nanaco会員限定!nanacoポイントがたまる保険 保険料カンタン見積り がん 医療 親介護">
					</a>
				</div>
			</div>
		</div>
	</div>
	<hr>
	<a href="/cp/index.html#mail_sns" class="campaign-banner Nanaco_CpRecommend">
		<img src="/material/img/common/bnr/bnr_cp_mailmagazine_sns_pc.png" width="100%" alt="キャンペーンなどおトク情報をお届け!! nanaco公式メルマガ・SNS いますぐここをクリック" class="pc-only">
		<img src="/material/img/common/bnr/bnr_cp_mailmagazine_sns_sp.png" alt="キャンペーンなどおトク情報をお届け!! nanaco公式メルマガ・SNS いますぐここをクリック" class="sp-only">
	</a>
</div>
`;
